export default __webpack_public_path__ + "static/media/rent-out-space3.ca0b95bf.png";